/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gpa_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An A- is 3.7 and a B+ is 3.3 on the 4.0 scale.`)
};

const es_gpa_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una A- es 3.7 y una B+ es 3.3 en la escala de 4.0.`)
};

const de_gpa_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf der 4,0-Skala entspricht ein A- 3,7 und ein B+ 3,3.`)
};

const nl_gpa_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een A- is 3,7 en een B+ is 3,3 op de schaal van 4,0.`)
};

const fr_gpa_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un A- vaut 3,7 et un B+ vaut 3,3 sur l'échelle de 4,0.`)
};

const it_gpa_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una A- vale 3,7 e una B+ vale 3,3 nella scala 4.0.`)
};

const pt_br2_gpa_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A- vale 3,7 e B+ vale 3,3 na escala de 4,0.`)
};

const pt_gpa_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um A- vale 3,7 e um B+ vale 3,3 na escala de 4,0.`)
};

const ja_gpa_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4.0スケールではA-は3.7、B+は3.3です。`)
};

const zh_gpa_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在 4.0 制下，A- 为 3.7，B+ 为 3.3。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gpa_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gpa_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gpa_ex3", locale)
	if (locale === "en") return en_gpa_ex3(inputs)
	if (locale === "es") return es_gpa_ex3(inputs)
	if (locale === "de") return de_gpa_ex3(inputs)
	if (locale === "nl") return nl_gpa_ex3(inputs)
	if (locale === "fr") return fr_gpa_ex3(inputs)
	if (locale === "it") return it_gpa_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_gpa_ex3(inputs)
	if (locale === "pt") return pt_gpa_ex3(inputs)
	if (locale === "ja") return ja_gpa_ex3(inputs)
	return zh_gpa_ex3(inputs)
};